<!--
 * @Author: xing.huang
 * @Date: 2021-02-03 10:15:40
 * @LastEditTime: 2021-04-01 16:44:54
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\report\CustomReport\CustomReportAddDialog.vue
 * @
-->
<template>
  <div class="add-custom-report">
    <el-row>
      <h3 style="text-align: center;">新增报表</h3>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="">
          <span class="title">报表类型：</span>
          <el-select style="max-width:180px" @change="propertyTypeChange" size="small" v-model="submitForm.propertyType" placeholder="报表类型">
            <el-option v-for="item in propertyTypeOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <span class="title">报表名称：</span>
          <el-input style="max-width:180px" size="small" v-model="submitForm.reportDataName" placeholder="报表名称"></el-input>
        </div>
      </el-col>
    </el-row>

    <div style="margin-top:20px;display:flex" :gutter="20">
      <div :span="2" style="flex:2">
        <draggable class="dragArea list-group tag-warp" :list="list" group="people">
          <div class="list-group-item" v-for="element in list" :key="element.propertyName">
            <el-tag class="tag">{{ element.propertyName }}</el-tag>
          </div>
        </draggable>
      </div>

      <div :span="21" style="margin:0 20px;flex:22">
        <div class="list-warp">
          <div class="item" v-for="(item, index) in columnList" :key="index">
            <div class="head">
              <el-input style="max-width:200px;margin:0px 6px" v-model="item.columnName" maxlength="16" placeholder="自定义名称"></el-input>
              <i class="el-icon-my-add icon-add" v-if="index == columnList.length - 1 && columnList.length < maxLen" @click="addItem"></i>
              <i class="el-icon-my-remove icon-del" :style="index == columnList.length - 1 ? { right: '22px' } : {}" v-if="columnList.length > 1" @click="delItem(index, item)"></i>
            </div>
            <div class="body">
              <draggable class="dragArea list-group" :list="item.list" group="people" @change="dragChange($event, item)">
                <div class="list-group-item" v-for="element in item.list" :key="element.propertyName">
                  <el-tag style="cursor: pointer;">{{ element.propertyName }}</el-tag>
                </div>
              </draggable>
              <el-menu
                v-if="item.propertyDataType == 0"
                :class="item.columnOption > -1 ? ['menu-item', 'el-icon-my-fn', 'el-icon-my-fn-active'] : ['menu-item', 'el-icon-my-fn']"
                mode="vertical"
                @select="handleSelect($event, item)"
                :collapse="false"
                :default-active="item.columnOption"
              >
                <el-menu-item v-for="item in columnOptionions" :key="'' + item.type" class="sub-item" style="padding-left: 6px;" :index="'' + item.type">{{ item.name }}</el-menu-item>
              </el-menu>
            </div>
          </div>
        </div>
        <div style="text-align:center;margin-top:20px">
          <el-button type="primary" @click="saveCustomReport">保 存</el-button>
          <!-- <el-button type="primary" @click="reViewCustomReport">预 览</el-button> -->
        </div>
      </div>
    </div>

    <el-dialog title="配置函数参数" :visible.sync="editDialogVisible" @close="cancelEditlog" :width="W ? '30%' : '68%'" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="addForm" class="addForm" style="margin-left:10px">
        <el-row :gutter="20" v-for="(item, index) in operatorList" :key="item.id">
          <el-col :span="16" :offset="4">
            <div>
              <span class="title">函数参数：</span>
              <el-form-item class="value">
                <el-select style="max-width:180px" filterable clearable @change="optionChange($event, index)" v-model="addForm.option[index]" size="small" maxlength="16" placeholder="函数参数">
                  <el-option v-for="item in selectList[index]" :key="item.id" :value="item.id" :label="item.columnName || item.propertyName"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="16" :offset="4"
            ><span>{{ addForm.text }}</span></el-col
          >
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateOption">确 定</el-button>
        <el-button @click="cancelEditlog">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "CustomReportAddDialog",
  components: {
    draggable
  },
  data() {
    return {
      submitForm: {
        propertyType: 0,
        reportDataName: ""
      },
      addForm: {
        option: [],
        text: ""
      },
      W: true,
      editDialogVisible: false,
      rules: {},
      columnOptionions: [
        //0-求最大值 1-求最小值 2-总计 3-加 4-减 5-乘 6-除
        { type: -1, name: "无函数" },
        { type: 0, name: "求最大值" },
        { type: 1, name: "求最小值" },
        { type: 2, name: "总计", operator: " + " },
        { type: 3, name: "加", operator: " + " },
        { type: 4, name: "减", operator: " - " },
        { type: 5, name: "乘", operator: "*" },
        { type: 6, name: "除", operator: "/" }
      ],
      propertyTypeOptions: [
        // 0-生产报表 1-质检报表 2-仓库报表 3-计划排程
        { value: 0, name: "生产报表" },
        { value: 1, name: "质检报表" },
        { value: 2, name: "仓库报表" },
        { value: 3, name: "计划排程" }
      ],
      list: [
        { propertyName: "报工月份", id: 1 },
        { propertyName: "报工日期", id: 2 },
        { propertyName: "订单号", id: 3 },
        { propertyName: "订单物料编码", id: 4 },
        { propertyName: "订单物料名称", id: 5 },
        { propertyName: "产品规格", id: 6 },
        { propertyName: "工单号", id: 7 },
        { propertyName: "工单物料编码", id: 8 },
        { propertyName: "工单物料名称", id: 9 },
        { propertyName: "工单规格", id: 10 },
        { propertyName: "机组", id: 11 },
        { propertyName: "计划开始时间", id: 12 },
        { propertyName: "计划结束时间", id: 13 },
        { propertyName: "数量", id: 14, propertyDataType: 0 },
        { propertyName: "工序名称", id: 15 },
        { propertyName: "设备", id: 16 },
        { propertyName: "执行人", id: 17 },
        { propertyName: "合格数量", propertyDataType: 0, id: 18 },
        { propertyName: "不合格数量", propertyDataType: 0, id: 19 }
      ],
      selectList: [],
      baseData: [],
      columnList: [
        { columnName: "", id: null, propertyName: "", type: 0, list: [] },
        { columnName: "", id: null, propertyName: "", type: 0, list: [] },
        { columnName: "", id: null, propertyName: "", type: 0, list: [] }
      ],
      maxLen: 19,
      operatorList: [],
      selectObj: {}
    };
  },
  created() {
    document.body.ondrop = function(event) {
      event.preventDefault();
      event.stopPropagation();
    };
  },
  mounted() {
    this.loadPropertyList(0);
  },
  methods: {
    async loadPropertyList(propertyType) {
      let { data, msg, code, message } = await this.$RequestUtil.getAsync({ url: "/api/customTable/listTableProperty", params: { propertyType } });
      if (code == 0) {
        this.list = data;
        this.baseData = commonUtils.cloneObj(data);
        this.maxLen = this.baseData.length;
      } else {
        this.$message.error(msg || message);
      }
    },

    async propertyTypeChange(ev) {
      await this.loadPropertyList(ev);
      this.columnList = [
        { columnName: "", id: null, propertyName: "", type: 0, list: [] },
        { columnName: "", id: null, propertyName: "", type: 0, list: [] },
        { columnName: "", id: null, propertyName: "", type: 0, list: [] }
      ];
    },

    dragChange: function(evt, item) {
      if (item.list.length > 1) {
        let [json1, json2] = item.list;
        item.list = [json2];
        this.list.push(json1);
        if (!item.columnName) {
          this.$set(item, "columnName", json2.propertyName);
        }
      } else {
        if (!item.columnName) {
          let columnName = item.list[0].propertyName;
          this.$set(item, "columnName", columnName);
        }
      }
      let json = item.list && item.list[0];
      if (json && json.propertyDataType != undefined) {
        let propertyDataType = json.propertyDataType;
        this.$set(item, "propertyDataType", propertyDataType);
      }
      item.id = json.id;
      item.propertyName = json.propertyName;
    },

    addItem() {
      this.columnList.push({ list: [] });
    },

    delItem(index, item) {
      this.list.push(...item.list);
      this.columnList.splice(index, 1);
    },

    handleSelect(ev, item) {
      this.$set(item, "columnOption", String(ev));
      this.headleOperator(ev, item);
    },

    headleOperator(type, item) {
      if (type <= 2) {
        return;
      }

      this.selectObj = item;

      this.operatorList = this.baseData.filter(item => item.propertyDataType == 0);
      this.operatorList.forEach(item => {
        let arr = commonUtils.cloneObj(this.operatorList);
        this.selectList.push(arr);
        this.addForm.option.push(null);
      });
      this.addForm.text = "";
      if (item.oldColumnOption && item.oldColumnOption == type) {
        this.addForm.option = item.propertyIdList;
        this.optionChange();
      }
      this.editDialogVisible = true;
    },

    optionChange(ev, index) {
      let idList = this.addForm.option.filter(item => item);
      this.addForm.option.forEach((item, i) => {
        let arr = this.operatorList.filter(f => !idList.includes(f.id));
        if (item) {
          let find = arr.find(fin => fin.id == item);
          if (!find) {
            arr.push(...this.operatorList.filter(f => f.id == item));
          }
        }
        this.$set(this.selectList, i, arr);
      });
      let str = "";
      if (idList.length >= 1) {
        let list = idList.map(id => {
          return this.operatorList.find(f => f.id == id);
        });
        let operator = this.columnOptionions.find(item => item.type == this.selectObj.columnOption).operator;

        list.forEach((item, index) => {
          if (index == 0) {
            str += item.columnName || item.propertyName;
          } else {
            str += operator + (item.columnName || item.propertyName);
          }
        });
        if (this.selectObj.columnOption == 2) {
          str = "(" + str + ")" + "/" + list.length;
        }
        str = "函数表达式 = " + str;
      }
      this.addForm.text = str;
    },

    updateOption() {
      this.selectObj.propertyIdList = this.addForm.option.filter(item => item);
      this.selectObj.oldColumnOption = this.selectObj.columnOption;
      this.cancelEditlog();
    },

    cancelEditlog() {
      this.addForm.option = [];
      this.selectList = [];
      this.editDialogVisible = false;
    },

    saveCustomReport() {
      let columnList = [];
      if (!this.submitForm.reportDataName) {
        this.$message.warning("自定义报表名称不能为空");
        return;
      }
      let isPass = true;
      let err_msg = [];
      this.columnList.forEach(item => {
        let json = {
          columnName: item.columnName,
          propertyIdList: [],
          columnOption: -1
        };
        if (item.columnOption != undefined) {
          json.columnOption = Number(item.columnOption);
          if (json.columnOption <= 2) {
            json.propertyIdList = [item.id];
          } else {
            json.propertyIdList = item.propertyIdList;
          }
        } else {
          json.propertyIdList = [item.id];
        }
        if (!item.columnName) {
          if (!err_msg.includes("自定义字段名称不能为空")) {
            err_msg.push("自定义字段名称不能为空");
          }
          isPass = false;
        }
        if (!item.id && item.columnName) {
          if (!err_msg.includes("自定义字段名称对应字段不能为空")) {
            err_msg.push("自定义字段名称对应字段不能为空");
          }
          isPass = false;
        }
        columnList.push(json);
      });
      if (!isPass) {
        let str = err_msg[0];
        if (err_msg.length == 2) {
          str = err_msg[0] + ",并且" + err_msg[1];
        }
        this.$message.warning(str);
        return;
      }

      this.submitForm.columnList = columnList;
      this.$RequestUtil.post({
        url: "/api/customTable/addReportData",
        params: { ...this.submitForm },
        success: res => {
          if (res.code == 0) {
            this.$message.success("新增成功");
            this.$router.push({ path: "/Report/CustomReport" });
            this.$store.commit("delete_tabs", `/Report/CustomReportAddDialog`);
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },

    reViewCustomReport() {}
  }
};
</script>
<style scoped>
.warp {
  border: 1px solid red;
  margin-bottom: 10px;
}
.tag-warp {
  border: 1px solid #dcdfe6;
  min-height: 200px;
  min-width: 130px;
}
.tag {
  cursor: pointer;
  margin: 6px 10px;
}
.list-warp {
  display: flex;
  width: 100%;
  border-right: 1px solid #ccc;
}
.list-warp .item {
  flex: 1;
  border-left: 1px solid #ccc;
}
.item .head {
  height: 42px;
  /* border-right: 1px solid #ccc; */
  border-top: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
}

.item .body {
  height: 36px;
  /* border-right: 1px solid #ccc; */
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  position: relative;
}
.icon-del {
  position: absolute;
  top: 2px;
  right: 2px;
}
.icon-add {
  position: absolute;
  top: 4px;
  right: 2px;
}
.body .list-group {
  height: 24px;
  padding: 6px 20%;
  font-size: 20px;
}
.head .icon-del {
  display: none;
}
.head:hover .icon-del {
  display: block;
}
.el-icon-my-fn {
  position: absolute;
  top: 14px;
  right: -1px;
}
.menu-item {
  /* width: 19px; */
  position: absolute;
  top: 16px;
  right: -1px;
}
.sub-item {
  display: none;
  padding: 10px 6px;
  border-left: 1px solid #dcdfe6;
  line-height: 46px;
  border-bottom: 1px solid #dcdfe6;
}
.el-icon-my-fn:hover {
  background-position: top right;
  background-size: 19px;
}
.el-icon-my-fn-active {
  background: url(../../../../static/img/function-hover.png);
  background-repeat: no-repeat;
  background-position: top right;
  background-size: contain;
}
.el-icon-my-fn:hover .sub-item {
  display: block;
}
.value {
  display: inline-block;
}
</style>
<style>
.add-custom-report .el-menu-item.is-active {
  background-color: #409eff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/report/CustomReport/CustomReportAddDialog.vue